const EventEmitter = require('./event-emitter');
const apiController = require('./api-controller');
const toastService = require('utils/toast-service');

var router = {

	ROUTE_EVENT: 'route',

	emitter: new EventEmitter(),

	params: {},

	publicResources: ['fer-alt-senha','logout','menu'],

	loadedResources: [{name: 'menu', paramStr: ''}],

	viewsStates: {},

	closeAllLoadedResources(){
		while (router.loadedResources.length > 1) {
			var res = router.loadedResources[router.loadedResources.length-1];
			router.unloadResource(res.name);
		}
		router.goHomePage();
	},

	unloadResource(resourceName,justRelease) {
		delete router.viewsStates[resourceName];
		router.loadedResources = router.loadedResources.filter(function(res){ return res.name != resourceName;});
		if (!justRelease){
			if (router.getWithoutParams() == resourceName) {
				router.goHomePage();
			} else {
				router.emitter.emit(router.ROUTE_EVENT);
			}
		}
	},

	getViewStateObject(viewName){
		if (router.viewsStates[viewName] == undefined) {
			router.viewsStates[viewName] = {
				dataLoaded: false
			};
		}
		return router.viewsStates[viewName];
	},

	unloadCurrentResource(){
		router.unloadResource(router.getWithoutParams());
	},

	goHomePage(){
		window.location.hash = '#/';
	},

	setParams(params) {
		var url = router.getWithoutParams();
		var i = 0
		for (var p in params) {
			url += ((i==0) ? '?' : '&') + p+'='+params[p];
			i++
		}
		window.location.hash = '#/'+url;
	},

	getWithoutParams(){
		if (typeof router.current == 'string') return router.current.split('?')[0];
	},

	getLoadedResource(resName){
		return $.grep(router.loadedResources,function(resource){
			return resource.name == resName;
		})[0];
	},

	mixin: {

		componentDidMount(){
			router.emitter.addEventListener(router.ROUTE_EVENT,this.refreshRoute);
		},

		componentWillUnmount(){
			router.emitter.removeEventListener(router.ROUTE_EVENT,this.refreshRoute);
		},

		refreshRoute(){
			if (this.isMounted()) this.setState({});
		}
	},

	extractParams(url){

		router.params = {};

		if (!(typeof url == 'string')) return;

		try {
			var str = url.split('?')[1];
  			if (!(typeof str == 'string')) return;
			
			str.split('&').map(function(item){
				var n = item.split('=')[0];
				var v = item.split('=')[1];
				router.params[n] = v;
			});

		} catch (e){}
	},

	handleHash(){

		var priorResName = (router.current) ? router.current.split('?')[0] : undefined;
		var url = location.hash || '#/';
		if (url.substr(0,2) == '#/') url = url.substr(2);

		var resName = url.split('?')[0];
		var strParams = url.split('?')[1];

		/*
    if (resName && router.publicResources.indexOf(resName) == -1 && !apiController.isAdmin() && apiController.acessos[resName] == undefined) {
			toastService.toast('Atenção, usuário não tem acesso ao recurso solicitado ('+resName+').','danger');
			router.goHomePage();
			return;
		}

		if (router.publicResources.indexOf(resName) == -1 && apiController.resources[resName] == undefined) {
			toastService.toast('Atenção, recurso inexistente no sistema ('+resName+').','danger');
			router.goHomePage();
			return;
		}
		*/

		if (resName == 'logout') {
			apiController.logout();
			router.closeAllLoadedResources();
			return;
		}

		router.current = url;

		//dispara o evento da mudança de rota
		router.emitter.emit(router.ROUTE_EVENT);

	}

};

window.addEventListener('hashchange',router.handleHash);

router.handleHash();

module.exports = router;


/** WEBPACK FOOTER **
 ** ./src/utils/router.js
 **/